export const DATENSCHUTZ_LINK_JOBS_DE = '/jobs/privacy-policy';
export const DATENSCHUTZ_LINK_JOBS_EN = '/jobs/privacy-policy-en';
export const IMPRESSUM_LINK = '/impressum';
export const AGB_LINK = '/agb';
export const DATENSCHUTZ_LINK = '/datenschutz';
export const INSTAGRAM_LINK = 'https://www.instagram.com/smava_gmbh/';
export const FACEBOOK_LINK =
  'https://www.facebook.com/people/smava/100064534726416/';
export const XTWITTER_LINK = 'https://twitter.com/smava';
export const YOUTUBE_LINK = 'https://www.youtube.com/@smava.';
export const LINKEDIN_LINK = 'https://de.linkedin.com/company/smava';
